import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const AlmacenesPadreApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAlmacenesPadre = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("almacenes_padre", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearAlmacenPadre = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("almacenes_padre", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteAlmacenPadre = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`almacenes_padre/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarAlmacenPadre = async (id, data) => {
        try {
            setCargando(true);

            const response = await api.put(`almacenes_padre/${id}`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getAcopios = async (params) => {
        return api
            .get("acopio", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getAlmacenesPadre,
        crearAlmacenPadre,
        deleteAlmacenPadre,
        actualizarAlmacenPadre,
        getAcopios,

        cargando,
    };
};
